'use strict';

var AudioControlsExtension = require('./AudioControlsExtension');
var CallFieldsExtension = require('./CallFieldsExtension');
var TooltipExtension = require('./TooltipExtension').default;
require('./CallTimerFilter');
require('./SelectMenuPositionService');
var log = require('../../log/Log').channel('CallCardController');
var defaults = require('../../defaults/Defaults');
var formatMeetingId = require('./FormatMeetingId');
var objectToArray = require('./ObjectToArray');
var sutl = require('../../sutl/Sutl');

angular
    .module('inara')
    .directive('aveoCallCard', function () {
        // Directive defining a card with call information and actions.
        return {
            restrict: 'E',
            templateUrl: 'callCard.html',
            scope: {
                call: '=',
                showUiDialString: '=?',
                showDialPadButton: '=?',
            },
            controller: 'CallCardController',
            controllerAs: 'vm',
            link: function (scope, element, attrs) {
                if (!angular.isDefined(scope.showUiDialString)) {
                    scope.showUiDialString = false;
                }
                if (!angular.isDefined(scope.showDialPadButton)) {
                    scope.showDialPadButton = false;
                }
            },
        };
    })

    .directive('aveoCallStatus', function () {
        // Directive defining call status for a call card
        return {
            restrict: 'E',
            templateUrl: 'callStatus.html',
            scope: {
                call: '=',
            },
        };
    })

    .filter('afterObjectKey', function () {
        return function (object, key) {
            var keys = Object.keys(object).sort();
            var filtered = angular.extend({}, object);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] === key) {
                    for (var j = 0; j < i; j++) {
                        delete filtered[keys[j]];
                    }
                    break;
                }
            }
            return filtered;
        };
    })

    .controller('CallCardController', CallCardController);

CallCardController.$inject = [
    '$scope',
    '$timeout',
    '$window',
    '$state',
    '$ionicPopover',
    '$ionicPosition',
    '$ionicViewSwitcher',
    'ionicMaterialInk',
    '$q',
    'KayleeService',
    'RoomService',
    'CallsService',
    'gettextCatalog',
    'SelectMenuPositionService',
    'IosTouchEventService',
    '$ionicScrollDelegate',
];

function CallCardController(
    $scope,
    $timeout,
    $window,
    $state,
    $ionicPopover,
    $ionicPosition,
    $ionicViewSwitcher,
    ionicMaterialInk,
    $q,
    KayleeService,
    RoomService,
    CallsService,
    gettextCatalog,
    SelectMenuPositionService,
    IosTouchEventService,
    $ionicScrollDelegate
) {
    var vm = this;

    var layoutLookup = {
        Gallery: {
            class: 'gallery',
            /// Zoom layout option button label
            label: gettextCatalog.getString('Gallery'),
            index: 3,
        },
        ShareAll: {
            class: 'content-only',
            /// Zoom layout option button label
            label: gettextCatalog.getString('Content Only'),
            index: 4,
        },
        Speaker: {
            class: 'speaker',
            /// Zoom layout option button label
            label: gettextCatalog.getString('Speaker'),
            index: 0,
        },
        Strip: {
            class: 'thumbnail',
            /// Zoom layout option button label
            label: gettextCatalog.getString('Thumbnail'),
            index: 1,
        },
    };

    // The controls object contains definitions of options (menu items) for use
    // on the call card itself or in popover menus triggered from the call card.
    // The definitions contain the classes, labels/text, and click handlers for
    // the options.
    // For functions in these definitions, 'this' is a call, since the functions
    // will be bound to the call object when they are created.
    var controls = {
        meeting: {
            definitions: {
                synergySkyControls: {
                    getIconClasses: function () {
                        return 'ion-android-more-horizontal';
                    },
                    onClick: function ($event) {
                        showControlPopover(controls.synergySkyDtmf, this, $event);
                    },
                    getLabel: function () {
                        return gettextCatalog.getString('Meeting Controls');
                    },
                    checkCall: function (call) {
                        return call.callExtendedType && call.callExtendedType.type === 'synergySky';
                    },
                },
                sendingVideo: {
                    getIconClasses: function () {
                        return this.sendingVideo
                            ? 'icon-dark ion-aveo-camera-started'
                            : 'muted ion-aveo-camera-stopped';
                    },
                    onClick: function ($event) {
                        this.$setSendVideo(!this.sendingVideo);
                    },
                    getLabel: function () {
                        /// Sending video start/stop button labels
                        return this.sendingVideo
                            ? gettextCatalog.getString('Stop Video')
                            : gettextCatalog.getString('Start Video');
                    },
                },
                sendingContent: {
                    getIconClasses: function () {
                        return 'online ion-aveo-share-screen';
                    },
                    onClick: function ($event) {
                        $state.go('control.display');
                    },
                    getLabel: function () {
                        /// Share content button label
                        return gettextCatalog.getString('Share Content');
                    },
                },
                layouts: {
                    getIconClasses: function () {
                        var availableLayouts = getAvailableLayouts();
                        var currentLayout = getCurrentLayout();
                        return availableLayouts &&
                            currentLayout &&
                            availableLayouts[currentLayout] &&
                            layoutLookup[availableLayouts[currentLayout]]
                            ? 'icon-dark ion-aveo-view-' +
                                  layoutLookup[availableLayouts[currentLayout]].class
                            : 'icon-dark ion-aveo-view-speaker';
                    },
                    onClick: function ($event) {
                        showControlPopover(controls.layouts, this, $event);
                    },
                    getLabel: function () {
                        /// Change view (layout) button label
                        return gettextCatalog.getString('Change View');
                    },
                    isDisabled: function (call) {
                        return (
                            call.callState !== 'connected' ||
                            getOptions(controls.layouts, call).length < 2
                        );
                    },
                },
                // canRecordMeeting: {
                //     getIconClasses: function() {
                //         return this.$recordingMeeting ?
                //             'muted ion-record' :
                //             'icon-dark ion-record';
                //     },
                //     onClick: function($event) {
                //         this.$recordingMeeting = !this.$recordingMeeting;
                //     },
                //     getLabel: function() {
                //         return this.$recordingMeeting ?
                //             'Stop Recording' :
                //             'Start Recording';
                //     }
                // }
            },
        },
        hangup: {
            popoverClass: 'hangup-options',
            definitions: {
                endmeeting: {
                    getClasses: function () {
                        return 'offhook';
                    },
                    onClick: function ($event) {
                        $scope.hangupMethod = 'endmeeting';
                        hideControlPopover(controls.hangup);
                    },
                    getButtonText: function () {
                        /// Zoom end meeting option button text
                        return gettextCatalog.getString('End');
                    },
                    getLabel: function () {
                        /// Zoom end meeting option button label
                        return gettextCatalog.getString('End Meeting for All');
                    },
                },
                hangup: {
                    getClasses: function () {
                        return 'muted';
                    },
                    onClick: function ($event) {
                        $scope.hangupMethod = 'hangup';
                        hideControlPopover(controls.hangup);
                    },
                    getButtonText: function () {
                        /// Zoom leave meeting option button text
                        return gettextCatalog.getString('Leave');
                    },
                    getLabel: function () {
                        /// Zoom leave meeting option button label
                        return gettextCatalog.getString('Leave Meeting');
                    },
                },
                cancel: {
                    onClick: function ($event) {
                        $scope.hangupMethod = 'cancel';
                        hideControlPopover(controls.hangup);
                    },
                    getButtonText: function () {
                        /// Zoom cancel end meeting option button text
                        return gettextCatalog.getString('Cancel');
                    },
                    getLabel: function () {
                        /// Zoom cancel end meeting option button label
                        return gettextCatalog.getString('Back to Meeting');
                    },
                },
            },
        },
        layouts: {
            popoverClass: 'layout-options',
            definitions: {},
        },
        synergySkyDtmf: {
            popoverClass: 'synergy-sky-dtmf-options',
            definitions: {
                nextLayout: {
                    getClasses: function () {
                        return 'button-text';
                    },
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.nextLayout);
                    },
                    getButtonText: function () {
                        return gettextCatalog.getString('Layout');
                    },
                },
                participants: {
                    getClasses: function () {
                        return 'button-text';
                    },
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.participants);
                    },
                    getButtonText: function () {
                        return gettextCatalog.getString('Participants');
                    },
                },
                chat: {
                    getClasses: function () {
                        return 'button-text';
                    },
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.chat);
                    },
                    getButtonText: function () {
                        return gettextCatalog.getString('Chat');
                    },
                },
                captions: {
                    getClasses: function () {
                        return 'button-text';
                    },
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.captions);
                    },
                    getButtonText: function () {
                        return gettextCatalog.getString('Captions');
                    },
                },
                raiseHand: {
                    getClasses: function () {
                        return 'button-text';
                    },
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.raiseHand);
                    },
                    getButtonText: function () {
                        return gettextCatalog.getString('Raise Hand');
                    },
                },
                thumbsUp: {
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.thumbsUp);
                    },
                    getIconImgSrc: function () {
                        return 'img/emoji-thumbs-up.svg';
                    },
                },
                heart: {
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.heart);
                    },
                    getIconImgSrc: function () {
                        return 'img/emoji-red-heart.svg';
                    },
                },
                applause: {
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.applause);
                    },
                    getIconImgSrc: function () {
                        return 'img/emoji-applause.svg';
                    },
                },
                laugh: {
                    onClick: function ($event) {
                        this.$dial(synergySkyDtmfCodes.laugh);
                    },
                    getIconImgSrc: function () {
                        return 'img/emoji-rotfl.svg';
                    },
                },
            },
        },
    };

    var callInfoItems = {
        zoom: {
            laptop: [
                {
                    label: gettextCatalog.getString('Go to'),
                    value: 'join.zoom.us',
                },
                {
                    /// Zoom meeting information label for the meeting ID
                    label: gettextCatalog.getString('Meeting ID'),
                    callProperty: 'dialString',
                    format: formatMeetingId,
                },
                {
                    /// Zoom meeting information label for the meeting password
                    label: gettextCatalog.getString('Password'),
                    callProperty: 'meetingPassword',
                },
                {
                    /// Zoom meeting information label for the meeting encryption type
                    label: gettextCatalog.getString('Encryption'),
                    /// Zoom meeting information value for the meeting encryption type
                    value: gettextCatalog.getString('Enhanced'),
                },
            ],
            phone: [
                {
                    /// Zoom meeting information label for the meeting ID
                    label: gettextCatalog.getString('Meeting ID'),
                    callProperty: 'dialString',
                    format: formatMeetingId,
                },
                {
                    /// Zoom meeting information label for the meeting password
                    label: gettextCatalog.getString('Password'),
                    callProperty: 'meetingPassword',
                },
                {
                    /// Zoom meeting information label for the participant ID
                    label: gettextCatalog.getString('Participant ID'),
                    callProperty: 'participantId',
                },
            ],
        },
    };

    var synergySkyDtmfCodes = {
        applause: '6',
        captions: '8',
        chat: '2',
        heart: '5',
        laugh: '*94',
        nextLayout: '0',
        participants: '3',
        raiseHand: '1',
        thumbsUp: '4',
    };

    var callInNumbers = [];
    var callInfoPopover = null;
    var callInCountriesMenu = null;
    var defaultCallInCountryId = 'US';
    var previousCallInList = null;
    var previousCallInListId = null;
    var previousCallInCountry = null;
    var previousCallLayouts = null;
    var previousCallExtendedState = null;
    var previousSendingVideo = null;
    var previousSendingContent = null;
    var room = RoomService.getRoom();
    var site = KayleeService.getSite(room.siteId);
    var hasKeyboard =
        angular.isDefined($window.cordova) &&
        angular.isDefined($window.cordova.plugins) &&
        angular.isDefined($window.cordova.plugins.Keyboard);

    vm.callInCountries = [];
    vm.callInCountry = null;
    vm.callInNumberLimit = 3;
    vm.dialBackspace = dialBackspace;
    vm.finishedSendingMeetingCodes = finishedSendingMeetingCodes;
    vm.getCallClass = getCallClass;
    vm.getCallInfoItemLabel = getCallInfoItemLabel;
    vm.getCallInfoItemValue = getCallInfoItemValue;
    vm.getCallInfoItems = getCallInfoItems;
    vm.getCallInNumbers = getCallInNumbers;
    vm.getEmptySelectionLabel = function () {
        /// Placeholder in selection box when nothing is selected yet
        return gettextCatalog.getString('Select...');
    };
    vm.getHangupMethod = getHangupMethod;
    vm.getMeetingControlOptions = getMeetingControlOptions;
    vm.getPasswordPlaceholder = function () {
        /// Placeholder text for meeting password input field
        return gettextCatalog.getString('Enter meeting password');
    };
    vm.getRecordingConsentMsg = getRecordingConsentMsg;
    vm.getRecordingConsentTitle = getRecordingConsentTitle;
    vm.hasCallInfo = hasCallInfo;
    vm.hasMeetingControlOptions = hasMeetingControlOptions;
    vm.hasPasswordError = hasPasswordError;
    vm.isCallInfoVisible = isCallInfoVisible;
    vm.isMeetingControlOptionDisabled = isMeetingControlOptionDisabled;
    vm.isPasswordFocused = false;
    vm.isPasswordRequired = isPasswordRequired;
    vm.isRecordingConsentRequired = isRecordingConsentRequired;
    vm.onKeydownPassword = onKeydownPassword;
    vm.onMoreCallInNumbersClicked = onMoreCallInNumbersClicked;
    vm.onSelectCallInCountry = onSelectCallInCountry;
    vm.onShowCallInfo = onShowCallInfo;
    vm.onShowCallInCountriesMenu = onShowCallInCountriesMenu;
    vm.onSubmitPassword = onSubmitPassword;
    vm.password = '';
    vm.showDialPad = showDialPad;

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    angular.extend(vm, new CallFieldsExtension());
    angular.extend(
        vm,
        new AudioControlsExtension(
            $scope,
            $ionicPopover,
            $timeout,
            $window,
            $ionicPosition,
            IosTouchEventService
        )
    );
    angular.extend(vm, new TooltipExtension($scope, $ionicPopover));

    if (!angular.isDefined($scope.call) || $scope.call === null) {
        log.error('call must be defined and non-null at initialization');
    }
    $scope.call.$onChange(onCallChanged);
    room.$onChange(onRoomChanged);

    $scope.$on('IdleTimeout', function () {
        vm.audiocontrols.hideAudioControls();
        hideMeetingControls();
    });

    $scope.$on('$destroy', function () {
        if ($scope.call) {
            $scope.call.$offChange(onCallChanged);
        }
        if (room) {
            room.$offChange(onRoomChanged);
            room = null;
        }
        vm.audiocontrols.hideAudioControls();
        hideMeetingControls();
        vm.tooltip.hide();
        if (callInCountriesMenu) callInCountriesMenu.remove();
        if (callInfoPopover) callInfoPopover.remove();
    });

    $scope.$on('popover.hidden', function ($event, popover) {
        for (var key in controls) {
            if (controls.hasOwnProperty(key) && popover === controls[key].popover) {
                popover.remove();
            }
        }
        if (popover === callInfoPopover || popover === callInCountriesMenu) popover.remove();
    });

    $scope.$on('popover.removed', function ($event, popover) {
        for (var key in controls) {
            if (controls.hasOwnProperty(key) && popover === controls[key].popover) {
                controls[key].popover = null;
                if (key === 'hangup') {
                    $scope.hangupMethodDeferred.resolve($scope.hangupMethod);
                }
            }
        }
        if (popover === callInfoPopover) callInfoPopover = null;
        if (popover === callInCountriesMenu) callInCountriesMenu = null;
    });

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'control.calls') {
            vm.audiocontrols.hideAudioControls();
            hideMeetingControls();
            vm.tooltip.hide();
            if (callInCountriesMenu) callInCountriesMenu.remove();
            if (callInfoPopover) callInfoPopover.remove();
        }
    });

    function buildLayoutControls() {
        var availableLayouts = getAvailableLayouts();
        if (availableLayouts === null) return;

        controls.layouts.definitions = {};
        for (var layoutId in availableLayouts) {
            if (!availableLayouts.hasOwnProperty(layoutId)) continue;

            if (!angular.isDefined(layoutLookup[availableLayouts[layoutId]])) continue;
            controls.layouts.definitions[layoutId] = createLayoutControl(layoutId);
        }

        function createLayoutControl(layoutId) {
            return {
                index: layoutLookup[availableLayouts[layoutId]].index,
                getClasses: function () {
                    return getCurrentLayout() === layoutId ? 'selected' : '';
                },
                getIconClasses: function () {
                    return (
                        'ion-aveo-view-' +
                        layoutLookup[availableLayouts[layoutId]].class +
                        ' ' +
                        (getCurrentLayout() === layoutId ? '' : 'icon-dark')
                    );
                },
                onClick: function ($event) {
                    if (room === null) return;
                    room.$requestCallLayout($scope.call.$id, layoutId);
                    hideControlPopover(controls.layouts);
                },
                getLabel: function () {
                    return layoutLookup[availableLayouts[layoutId]].label;
                },
            };
        }
    }

    function dialBackspace(call) {
        call.$uiDialString = call.$uiDialString.slice(0, -1);
    }

    function finishedSendingMeetingCodes(call) {
        return (
            call.hasOwnProperty('meetingCodes') &&
            Date.now() - call.start >
                (Object.keys(call.meetingCodes).length + 1) * defaults.inara.meetingCodeSendDelay +
                    (angular.isDefined(call.dialPrefix)
                        ? site.settings.telephonyDialingPrefixDelay * 1000
                        : 0)
        );
    }

    function getAvailableLayouts() {
        return sutl.getNode($scope.call, ['layouts', 'available']);
    }

    function getCallClass() {
        var callType = sutl.getNode($scope, ['call', 'callType']);
        return callType === null ? 'audio' : KayleeService.getCallClass(callType);
    }

    function getCallInfoItemLabel(item) {
        return sutl.getNode(item, 'label');
    }

    function getCallInfoItemValue(item) {
        var prop = sutl.getNode(item, 'value');
        var format = sutl.getNode(item, 'format');
        if (prop !== null) return prop;
        prop = sutl.getNode(item, 'callProperty');
        if (prop !== null) {
            return format !== null
                ? format(sutl.getNode($scope.call, prop))
                : sutl.getNode($scope.call, prop);
        }
        return null;
    }

    function getCallInfoItems(itemCategory) {
        var callType = sutl.getNode($scope, 'call.callType');
        return callType === null ? null : sutl.getNode(callInfoItems, [callType, itemCategory]);
    }

    function getCallInNumbers(callInCountry) {
        var callInListId = sutl.getNode($scope, 'call.callInListId');
        if (callInCountry === null || callInCountry === previousCallInCountry) {
            return callInNumbers;
        }
        if (callInListId === null) {
            if (callInNumbers && callInNumbers.length > 0) callInNumbers = [];
            return callInNumbers;
        }
        var callInList = objectToArray(
            sutl.deepCopy(sutl.getNode(room, ['states', 'callInLists', callInListId], []))
        );
        callInNumbers = callInList.filter(function (el) {
            return el.countryId === callInCountry.countryId;
        });
        previousCallInCountry = callInCountry;
    }

    function getCurrentLayout() {
        return sutl.getNode($scope.call, ['layouts', 'current']);
    }

    function getHangupMethod(call, $event) {
        if (call.canEndMeeting) {
            $scope.hangupMethod = 'cancel';
            $scope.hangupMethodDeferred = $q.defer();
            showControlPopover(controls.hangup, call, $event);
            return $scope.hangupMethodDeferred.promise;
        }
        return null;
    }

    function getMeetingControlOptions(call) {
        return getOptions(controls.meeting, call, true);
    }

    function getOptions(control, call, propsMustBeInCall) {
        if (!control.bound) {
            control.bound = true;
            // If this is the first call to getOptions for this control, bind
            // the control option functions to the call object.
            // Optionally, if propsMustBeInCall is truthy, then the properties
            // in the definitions must also be present in the call object in
            // order to be bound.
            for (var defKey in control.definitions) {
                if (!control.definitions.hasOwnProperty(defKey)) continue;
                if (propsMustBeInCall) {
                    if (typeof control.definitions[defKey].checkCall === 'function') {
                        if (!control.definitions[defKey].checkCall(call)) continue;
                    } else if (!call.hasOwnProperty(defKey)) continue;
                }
                var option = { name: defKey };
                for (var funcKey in control.definitions[defKey]) {
                    if (!control.definitions[defKey].hasOwnProperty(funcKey)) continue;
                    if (typeof control.definitions[defKey][funcKey] === 'function') {
                        option[funcKey] = control.definitions[defKey][funcKey].bind(call);
                    } else {
                        option[funcKey] = control.definitions[defKey][funcKey];
                    }
                }
                if (!angular.isDefined(control.options)) control.options = [];
                control.options.push(option);
            }
        }
        return control.options;
    }

    function getRecordingConsentMsg() {
        /// Zoom consent to recording dialog message
        return gettextCatalog.getString(
            'By staying in this meeting, you consent to being ' +
                'recorded. The account owner and host can watch Zoom Cloud recordings and any ' +
                'participant with permission can record to their local device. These individuals ' +
                'can share these recordings with apps and others.'
        );
    }

    function getRecordingConsentTitle() {
        /// Zoom consent to recording dialog title
        return gettextCatalog.getString('This Meeting is Being Recorded');
    }

    function hasCallInfo(call) {
        var callType = sutl.getNode($scope, 'call.callType');
        return callType !== null && sutl.getNode(callInfoItems, callType) !== null;
    }

    function hasMeetingControlOptions(call) {
        if (call && $state.current.name !== 'control.call-dialpad') {
            for (var prop in controls.meeting.definitions) {
                if (!controls.meeting.definitions.hasOwnProperty(prop)) continue;
                if (
                    typeof controls.meeting.definitions[prop].checkCall === 'function' &&
                    controls.meeting.definitions[prop].checkCall(call) === true
                ) {
                    return true;
                } else if (angular.isDefined(call[prop])) {
                    return true;
                }
            }
        }
        return false;
    }

    function hasPasswordError(call) {
        return (
            call.callExtendedState === 'passwordError' &&
            vm.callForm.$pristine &&
            !vm.callForm.$submitted
        );
    }

    function hideCallInCountriesMenu() {
        if (callInCountriesMenu !== null) return callInCountriesMenu.remove();
        return $q.resolve();
    }

    function hideCallInfo() {
        if (callInfoPopover !== null) return callInfoPopover.remove();
        return $q.resolve();
    }

    function hideControlPopover(control) {
        if (!angular.isDefined(control.popover)) control.popover = null;
        if (control.popover !== null) return control.popover.remove();
        return $q.resolve();
    }

    function hideMeetingControls() {
        for (var key in controls) {
            if (!controls.hasOwnProperty(key)) continue;
            hideControlPopover(controls[key]);
        }
    }

    function isCallInfoVisible(call) {
        return callInfoPopover !== null;
    }

    function isMeetingControlOptionDisabled(meetingControlOption, call) {
        if (typeof meetingControlOption.isDisabled === 'function') {
            return meetingControlOption.isDisabled(call);
        }
        return call.callState !== 'connected';
    }

    function isPasswordRequired(call) {
        return (
            angular.isDefined(call) &&
            call !== null &&
            call.callState !== 'disconnecting' &&
            call.callState !== 'disconnected' &&
            call.callState !== 'connected' &&
            angular.isDefined(call.callExtendedState) &&
            call.callExtendedState !== null &&
            call.callExtendedState.startsWith('password')
        );
    }

    function isRecordingConsentRequired(call) {
        return (
            angular.isDefined(call) &&
            call !== null &&
            call.callState !== 'disconnecting' &&
            call.callState !== 'disconnected' &&
            call.callExtendedState === 'recordingConsentRequired'
        );
    }

    function onCallChanged() {
        var availableLayouts = getAvailableLayouts();
        if (
            previousCallLayouts === null ||
            !sutl.objEquals(previousCallLayouts, availableLayouts) ||
            (previousSendingVideo === null && sutl.getNode($scope, 'call.sendingVideo') !== null) ||
            (previousSendingContent === null &&
                sutl.getNode($scope, 'call.sendingContent') !== null)
        ) {
            previousCallLayouts = angular.copy(availableLayouts);
            buildLayoutControls();
            // update meeting controls on call card
            controls.meeting.options = [];
            controls.meeting.bound = false;
            controls.layouts.options = [];
            controls.layouts.bound = false;
        }
        if (
            $scope.call &&
            (previousCallExtendedState === null ||
                !angular.isDefined(previousCallExtendedState) ||
                previousCallExtendedState !== $scope.call.callExtendedState)
        ) {
            if (
                $scope.call.callExtendedState === 'password' ||
                $scope.call.callExtendedState === 'passwordError'
            ) {
                vm.password = '';
                if (angular.isDefined(vm.callForm)) {
                    vm.callForm.$setPristine();
                }
                $timeout(function () {
                    vm.isPasswordFocused = true;
                }, 200);
            }
            previousCallExtendedState = $scope.call.callExtendedState;
        }
        previousSendingVideo = sutl.getNode($scope, 'call.sendingVideo');
        previousSendingContent = sutl.getNode($scope, 'call.sendingContent');
        updateCallInfo();
    }

    function onKeydownPassword($event) {
        if ($event.keyCode === 13 && vm.callForm.$valid) {
            vm.isPasswordFocused = false;
            if ($event.stopPropagation) $event.stopPropagation();
            if (hasKeyboard) $window.cordova.plugins.Keyboard.close();
            vm.callForm.$setSubmitted();
            onSubmitPassword($event);
        }
    }

    function onMoreCallInNumbersClicked($event) {
        var numbers = getCallInNumbers(vm.callInCountry);
        if (!numbers || numbers.length <= vm.callInNumberLimit) return;
        numbers = numbers.slice(vm.callInNumberLimit).map(function (el) {
            return el.displayDialString;
        });
        vm.tooltip.show(numbers, $event);
    }

    function onRoomChanged() {
        updateCallInfo();
    }

    function onSelectCallInCountry(country) {
        vm.callInCountry = country;
        hideCallInCountriesMenu();
    }

    function onShowCallInfo(call, $event) {
        hideCallInfo().then(function () {
            return $ionicPopover
                .fromTemplateUrl('callInfoPopover.html', {
                    scope: $scope,
                })
                .then(function (popover) {
                    callInfoPopover = popover;
                    return callInfoPopover.show($event);
                });
        });
    }

    function onShowCallInCountriesMenu($event) {
        hideCallInCountriesMenu().then(function () {
            return $ionicPopover
                .fromTemplateUrl('countriesMenu.html', {
                    scope: $scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: SelectMenuPositionService.createPositionViewHandler(
                        '#dummy-source-item',
                        vm.callInCountries ? vm.callInCountries.length : 0
                    ),
                })
                .then(function (popover) {
                    callInCountriesMenu = popover;
                    return callInCountriesMenu.show($event).then(scrollToSelectedCountry);
                });
        });
    }

    function scrollToSelectedCountry() {
        if (callInCountriesMenu === null || vm.callInCountry === null) return;

        var item = callInCountriesMenu.modalEl.querySelector('#' + vm.callInCountry.countryId);
        if (!item) return;
        if (item.offsetTop < callInCountriesMenu.modalEl.scrollTop) {
            $ionicScrollDelegate.$getByHandle('countries-scroll').scrollTo(0, item.offsetTop, true);
        } else if (item.offsetTop + item.offsetHeight > callInCountriesMenu.modalEl.clientHeight) {
            $ionicScrollDelegate
                .$getByHandle('countries-scroll')
                .scrollTo(
                    0,
                    item.offsetTop + item.offsetHeight - callInCountriesMenu.modalEl.clientHeight,
                    true
                );
        }
    }

    function onSubmitPassword($event) {
        vm.isPasswordFocused = false;
        room.$requestSendMeetingCode($scope.call.$id, vm.password);
    }

    function showControlPopover(control, call, $event) {
        return hideControlPopover(control).then(function () {
            $scope.options = getOptions(control, call);
            $scope.popoverClass =
                control.popoverClass + ' ' + 'options-count-' + $scope.options.length;
            return $ionicPopover
                .fromTemplateUrl('callOptionsPopover.html', {
                    scope: $scope,
                })
                .then(function (popover) {
                    control.popover = popover;
                    // HACK: Using this timeout to allow ng-class in the popover
                    // template to digest. Without it, the show classes are
                    // applied before any preliminary popoverClass supplied
                    // in the scope can be processed.
                    return $timeout(1).then(function () {
                        return control.popover.show($event);
                    });
                });
        });
    }

    function showDialPad($event, call) {
        $ionicViewSwitcher.nextDirection('forward');
        $state.go('control.call-dialpad', {
            call: call.$id,
            calendarEventId: call.calendarEventId,
        });
    }

    function updateCallInfo() {
        var callInListId = sutl.getNode($scope, 'call.callInListId');
        if (callInListId === null) return;
        var callInList = sutl.getNode(
            room,
            ['states', 'callInLists', $scope.call.callInListId],
            []
        );
        if (
            !sutl.objEquals(callInList, previousCallInList) ||
            callInListId !== previousCallInListId
        ) {
            for (var i = 0; i < callInList.length; i++) {
                if (!vm.callInCountries.find(byId)) {
                    vm.callInCountries.push({
                        name: callInList[i].name,
                        countryId: callInList[i].countryId,
                    });
                }
            }

            var callInCountryId = sutl.getNode(
                $scope,
                'call.defaultCallInCountryId',
                defaultCallInCountryId
            );
            vm.callInCountry = vm.callInCountries.find(function (el) {
                return el.countryId === callInCountryId;
            });

            previousCallInList = callInList;
            previousCallInListId = callInListId;
        }

        function byId(el) {
            return el.countryId === callInList[i].countryId;
        }
    }
}

module.exports = CallCardController;
